module.exports = __webpack_public_path__ + "static/media/mask10.61f92d61.svg";